import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Business, Review } from '../types';

interface DeepLinkHandlerProps {
  businesses: Business[];
  onBusinessSelect: (business: Business) => void;
  onReviewSelect?: (review: Review) => void;
}

const DeepLinkHandler: React.FC<DeepLinkHandlerProps> = ({ 
  businesses, 
  onBusinessSelect,
  onReviewSelect 
}) => {
  const { businessId, reviewId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (businessId) {
      const business = businesses.find(b => b.id === businessId);
      if (business) {
        onBusinessSelect(business);
        
        // If we have a specific review ID, handle that too
        if (reviewId && onReviewSelect) {
          // In a real app, you'd fetch the specific review
          console.log(`Deep linking to review ${reviewId} for business ${businessId}`);
        }
      } else {
        // Business not found, redirect to home
        console.warn(`Business with ID ${businessId} not found`);
        navigate('/');
      }
    }
  }, [businessId, reviewId, businesses, onBusinessSelect, onReviewSelect, navigate]);

  return null; // This component doesn't render anything
};

export default DeepLinkHandler;
